// src/components/ui/Spinner.jsx
import { C } from '../../styles/tokens';

export default function Spinner({ size = 24, color = C.magenta }) {
  return (
    <div style={{
      width: size, height: size,
      border: `2px solid rgba(255,255,255,0.1)`,
      borderTopColor: color,
      borderRadius: '50%',
      animation: 'spin 0.6s linear infinite',
      display: 'inline-block',
    }} />
  );
}

export function PageLoader() {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: C.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: '16px', zIndex: 9999,
    }}>
      <div style={{
        width: '44px', height: '44px', borderRadius: '11px',
        background: `linear-gradient(135deg, ${C.magenta}, ${C.violet})`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '22px', animation: 'glow 2s ease-in-out infinite',
      }}>⬡</div>
      <Spinner size={32} />
      <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>Loading Oracle Nexus…</span>
    </div>
  );
}
